import { css } from '@emotion/core';
import { tokens, applyFont } from '@domain-group/fe-brary';
import { truncateLines } from '@domain-group/fe-co-allhomes-design-system';
const colors = tokens.colors,
  typography = tokens.typography;
export const articleCard = hasBorder => /*#__PURE__*/css("width:100%;border-radius:3px;overflow:hidden;min-height:124px;display:flex;align-items:stretch;", hasBorder && /*#__PURE__*/css("border:1px solid ", colors.neutral.trim.default, ";&:hover{box-shadow:0 5px 40px 0 ", colors.neutral.trim.default, ";}"));
var _ref = {
  name: "zcxndt",
  styles: "align-items:center;"
};
export const link = isCentered => /*#__PURE__*/css("flex-grow:1;flex-direction:column;display:flex;text-decoration:none;color:", colors.neutral.heavy.default, ";", isCentered && _ref);
export const content = hasBorder => /*#__PURE__*/css("display:flex;justify-content:space-between;align-items:stretch;flex-grow:1;", hasBorder && /*#__PURE__*/css("border-top:6px solid ", colors.neutral.heavy.default, ";"));
export const topImageContainer = isLarge => /*#__PURE__*/css("display:block;height:", isLarge ? '200px' : '148px', ";width:", isLarge ? '100%' : 'auto', ";img{width:100%;height:100%;object-fit:cover;}");
export const leftImageContainer = {
  name: "1h2swia",
  styles: "display:block;width:90px;img{width:100%;min-width:90px;height:100%;object-fit:cover;}"
};
export const tags = {
  name: "1krlz36",
  styles: "display:flex;flex-wrap:wrap;overflow:hidden;max-height:24px;align-self:flex-start;gap:8px;"
};

// FIXME: Need to remove the margins in the design system,
//        but that'll have potential flow-on effects elsewhere
export const tag = {
  name: "qau5kf",
  styles: "margin:0;text-shadow:none;"
};
var _ref2 = {
  name: "4h06o",
  styles: "padding:16px;justify-content:space-between;gap:12px;"
};
var _ref3 = {
  name: "8rtx9s",
  styles: "gap:8px;padding:16px 0;"
};
export const middle = isResearchAppearance => /*#__PURE__*/css("display:flex;flex-direction:column;flex-grow:1;", !isResearchAppearance && _ref2, " ", isResearchAppearance && _ref3);
export const heading = hasLineLimit => /*#__PURE__*/css(applyFont(typography.subheading), " ", hasLineLimit && /*#__PURE__*/css(truncateLines(2)));

// Body long doesn't exist in the tokens
const bodyLongLineHeight = 24;
export const description = _ref4 => {
  let fixedHeight = _ref4.fixedHeight,
    maxLines = _ref4.maxLines;
  return /*#__PURE__*/css(truncateLines(maxLines), " ", applyFont(typography.body), " line-height:", bodyLongLineHeight, "px;color:", colors.neutral.heavy.default, ";margin-bottom:16px;", fixedHeight && /*#__PURE__*/css("height:", maxLines * bodyLongLineHeight, "px;"));
};
export const arrow = {
  name: "1p57ph1",
  styles: "padding-top:16px;padding-right:10px;"
};